import { TopPage } from "@/components/elements/TopPage";
import { COMPANY_CONTAINER } from "@/constants/ui";
import { ContactTypeForm } from "@/features/contact/components/ContactTypeForm";
import { Stack } from "@mui/material";
import { FC } from "react";

type TContactTypeCreatePageProps = {
  isCompany: boolean;
};

export const ContactTypeCreatePage: FC<TContactTypeCreatePageProps> = ({ isCompany }) => {
  return (
    <Stack>
      <TopPage title="お問い合わせ管理" enablePageBack={false} />
      <Stack maxWidth={COMPANY_CONTAINER}>
        <ContactTypeForm isCompany={isCompany} />
      </Stack>
    </Stack>
  );
};
